import { useContext, useState } from 'react'
import ApiContext from 'src/provider/API/call-service'
import {Identification, NewPassword, OtpVerification, SecurityQuestionValidation} from 'src/component'

export const ForgotPassword: React.FC<any> = ({close}) => {
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({username: '', securityAnswer1: '', securityAnswer2: '', txPin: '', otp: ''})
    const [view, setView] = useState('identification')

    const handleInput = async (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
        if (e.target.name === 'txPin' && e.target.value.length > 4) return false
        
        setInput({...input, [e.target.name]: e.target.value})
    }

    async function handlePasswordChange() {
        await API.resetPassword(input)
        close()
    }

    return (
        <>
            { view === 'identification' ?
                <Identification 
                    close={close}
                    formData={input}
                    handleInput={handleInput}
                    next={() => setView('security-questions')}
                />
                    : view === 'security-questions' ?
                        <SecurityQuestionValidation 
                            close={close}
                            formData={input}
                            handleInput={handleInput}
                            next={() => setView('otp-verification')}
                        />
                            : view === 'otp-verification' ?
                                <OtpVerification 
                                    close={close}
                                    formData={input}
                                    resendOtpMethod={() => API.validateSecurityAnswers(input)}
                                    handleInput={handleInput}
                                    next={() => setView('new-password')}
                                />
                                    : view === 'new-password' ?
                                        <NewPassword
                                            close={close}
                                            formData={input}
                                            handleInput={handleInput}
                                            next={handlePasswordChange} 
                                        />
                                            : null
            }
        </>
    )
}